import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { EditorModule } from 'primeng/editor';
import { Router } from '@angular/router';
import { UserService } from '../../layout/service/user.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-notes-create',
    standalone: true,
    imports: [CommonModule, FormsModule, ButtonModule, InputTextModule, EditorModule, ToastModule],
    template: `
        <div class="p-6">
            <h1 class="text-3xl font-bold mb-6">Create Note</h1>
            <div class="space-y-4">
                <div>
                    <label class="block text-sm font-medium mb-2">Note</label>
                    <p-editor [(ngModel)]="note.note" [style]="{'height':'320px'}"></p-editor>
                </div>
                <div class="flex gap-4">
                    <button pButton label="Save" (click)="saveNote()"></button>
                    <button pButton label="Cancel" class="p-button-secondary" (click)="cancel()"></button>
                </div>
            </div>
        </div>
        <p-toast></p-toast>
    `,
    providers: [MessageService]
})
export class NotesCreate {
    note = { USER_ID: '', note: '' };

    constructor(
        private userService: UserService,
        private router: Router,
        private messageService: MessageService
    ) {}

    ngOnInit() {
        const userStr = localStorage.getItem('user');
        if (userStr) {
            const user = JSON.parse(userStr);
            this.note.USER_ID = user.ID_USER || '1';
        } else {
            this.note.USER_ID = '1';
        }
    }

    saveNote() {
        this.userService.addNotes(this.note).then(() => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Note created' });
            this.router.navigate(['/app/notes']);
        }).catch(err => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create note' });
        });
    }

    cancel() {
        this.router.navigate(['/app/notes']);
    }
}